import { makeStyles, withStyles } from '@material-ui/core/styles'
import StepConnector from '@material-ui/core/StepConnector'

const activeStepLable = {
  color: '#183560',
  fontWeight: 700,
}

export default makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',

    '& .MuiStepper-root': {
      width: '100%',
      maxWidth: 450,
      backgroundColor: 'transparent',
      padding: 0,
      margin: '60px 0 0 0',

      '& .MuiStepLabel-root': {
        '& .MuiStepLabel-label': {
          fontSize: 16,
          fontWeight: 400,
          color: '#5D7290',
          fontStyle: 'normal',
          lineHeight: '24px',

          '&.MuiStepLabel-active': {
            ...activeStepLable,
          },

          '&.MuiStepLabel-completed': {
            ...activeStepLable,
          },
        },
      },
    },
  },
}))

const defaultStep = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 30,
  height: 30,
  borderRadius: '50%',
  backgroundColor: '#FFFFFF',
}

export const useStepIconStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  active: {
    ...defaultStep,
    border: '1px solid #183560',
    '& div': {
      width: 12,
      height: 12,
      borderRadius: '50%',
      border: 'none',
      backgroundColor: '#183560',
    },
  },
  circle: {
    ...defaultStep,
    border: '1px solid #C5C5C5',
    zIndex: 1,
    '& div': {
      width: 12,
      height: 12,
      borderRadius: '50%',
      backgroundColor: 'transparent',
    },
  },
  completed: {
    ...defaultStep,
    backgroundColor: '#183560',
    color: '#FFFFFF',
  },
})

export const Connector = withStyles({
  alternativeLabel: {
    top: 15,
    left: 'calc(-50% + 15px)',
    right: 'calc(50% + 15px)',
  },
  line: {
    borderColor: '#C5C5C5',
    borderTopWidth: 1,
    borderRadius: 0,
  },
})(StepConnector)
